import { SliderField } from '../SliderField/SliderField';
import type { FormProps } from '@builder4/shared/components/Form';
import { useInspectorNode } from '@/hooks/useInspectorNode';

interface FieldStrokeWidthProps {
  fieldInputBorderWidth: number;
}

const NodeFieldStrokeWidth = () => {
  const { id, props, actions } = useInspectorNode<FieldStrokeWidthProps>((p) => ({
    fieldInputBorderWidth: (p.fieldInputBorderWidth as number) ?? 1,
  }));

  const updateStrokeWidth = (value: number, skipHistory = false) => {
    const actionMethod = skipHistory ? actions.history.ignore().setProp : actions.setProp;
    actionMethod(id, (props: FormProps) => {
      props.fieldInputBorderWidth = value;
    });
  };

  const handleOnChange = (e: number) => {
    updateStrokeWidth(e, true);
  };

  const handleOnChangeComplete = (value: number, initialValue: number) => {
    updateStrokeWidth(initialValue, true);
    updateStrokeWidth(value);
  };

  return (
    <SliderField
      label="Stroke"
      value={props.fieldInputBorderWidth}
      onChange={handleOnChange}
      onChangeComplete={handleOnChangeComplete}
      min={0}
      max={100}
    />
  );
};

export default NodeFieldStrokeWidth;
